import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Close from '@mui/icons-material/Close';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Field } from 'redux-form';
import { TintedIconButton } from '@/ui';

const Value = ({ input }) => (
  <>
    <TextField {...input} placeholder='Value' multiline minRows={1} />
    {!input.value && (
      <Typography
        variant='caption'
        color='text.secondary'
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}
      >
        <InfoOutlined sx={{ fontSize: '0.875rem' }} />
        If the value is left empty, the Layout/Container must have a failsafe configured.
      </Typography>
    )}
  </>
);

const Key = ({ input, meta, customVarFlag }) => {
  const handleChange = (e) => {
    input.onChange(customVarFlag + e.target.value);
  };

  const handleBlur = (e) => {
    const currentValue = e.target.value;
    if (!currentValue.startsWith(customVarFlag)) {
      input.onBlur(customVarFlag + currentValue);
    } else {
      input.onBlur(currentValue);
    }
  };

  const displayValue = input.value.startsWith(customVarFlag) ? input.value.slice(customVarFlag.length) : input.value;

  return (
    <TextField
      {...input}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder='Key'
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error ? meta.error : undefined}
      slotProps={{ input: { startAdornment: <InputAdornment position='start'>{customVarFlag}</InputAdornment> } }}
    />
  );
};

export default function CustomVariableItem({ customVariablesItem, index, fields, customVarFlag }) {
  return (
    <Card sx={{ mb: 1 }}>
      <CardContent>
        {/* Key, value and the remove control share one row; the delete used to sit alone on a
            line of its own above two stacked full-width fields. */}
        <Stack direction='row' spacing={2} sx={{ alignItems: 'flex-start' }}>
          <Box sx={{ flex: '0 0 34%' }}>
            <Field name={`${customVariablesItem}.key`} type='text' component={Key} customVarFlag={customVarFlag} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Field name={`${customVariablesItem}.value`} type='text' component={Value} />
          </Box>
          {/* The same tinted remove button the offer action rows use. */}
          <TintedIconButton
            color='error'
            aria-label='Remove custom variable'
            title='Remove custom variable'
            onClick={() => fields.remove(index)}
          >
            <Close />
          </TintedIconButton>
        </Stack>
      </CardContent>
    </Card>
  );
}
